type Features = readonly string[] | null | undefined;
/**
 * Determines if a user is targeted for benefits-focused features.
 */
export function isBenefitsTargeted(features: Features): boolean {
  return (
    features?.includes("MAXIMIZE_BENEFITS") === true &&
    !isBillCheckingTargeted(features)
  );
}
/**
 * Determines if a user is targeted for fix billing errors.
 */
export function isBillCheckingTargeted(features: Features): boolean {
  return features?.includes("FIX_BILLING_ERRORS") ?? false;
}
/**
 * Determines if a user explicitly chose the save-on-future-bills intent.
 */
export function isSaveTargeted(features: Features): boolean {
  return features?.includes("SAVE_FUTURE_BILLS") ?? false;
}
/**
 * Determines if intake routing already showed the user its education pitch.
 */
export function hasSeenRoutingPitch(features: Features): boolean {
  return features?.includes("SAW_ROUTING_PITCH") ?? false;
}
